import { render } from "./Balance.vue?vue&type=template&id=6bdff248&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=6bdff248&lang=scss&scoped=true"
import "./Balance.vue?vue&type=style&index=1&id=6bdff248&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdff248"]])

export default __exports__